import React, { useState } from 'react'
import axios from 'axios'
// import PropTypes from 'prop-types'
import TextField from './../../../Atoms/TextField'
import InputSelect,{InputSelectType} from './../../../Atoms/InputSelect'

function MSolicitarPartModal(props) {
    const {
        title,
        name,
        fc_DESCRIPCION,
        lstPlanContratacionxPlan,
        optionsCiudades,
        Caracteristicas,
        fi_PLAN,
        fi_SERVICIO,
    } = props
    const [callCond, setCallCond] = useState(fi_SERVICIO !== null ? true : false)
    const [alertCond, setAlertCond] = useState(false)
    //const [phoneCode, setPhoneCode] = useState("+569")
    //const [localTelefono_tipo, setLocalTelefono_tipo] = useState("")
    //const [maxlengthPhone, setMaxlengthPhone] = useState(8)
    //const [statusClass, setStatusClass] = useState('')
    //const [localTelefono, setLocalTelefono] = useState('')
    //const [errorField, setErrorField] = useState('')
    //const [notification, setNotification] = useState('')
    //const [inputDisabled, setInputDisabled] = useState(false)

    
    const [disabledContinua, setDisabledContinua] = useState(false)
    const [ciudad, setCiudad] = useState('-1')
    const [idSolicitud, setIdSolicitud] = useState(null)
    const [tipo_telefono, setTipo_telefono] = useState(null)
    const [telefono, setTelefono] = useState('')
    const [extension] = useState('')
    const [autorizacion, setAutorizacion] = useState(false)
    const [success, setSuccess] = useState(false)
    const [errors, setErrors] = useState({})
    const [ciudadName, setCiudadName] = useState('')
    const [mensajeSolicitud, setMensajeSolicitud] = useState('')



    const onSubmitForm = data => {
        data.preventDefault()

        let idProducto = PlanContratacionCAL[0]?.fc_TIPO_CAMPANIA
        console.log("PlanContratacionCAL", PlanContratacionCAL, idProducto)

        setDisabledContinua(true)
        let errors = {}
        if (!ciudad || ciudad === '-1') {
            errors = {
                ciudad: {
                    message: 'Selecciona la ciudad para el servicio.'
                }
            }
        }

        // if (!idProducto || idProducto === '-1') {
        //       errors = {
        //             ...errors,
        //             producto: {
        //                 message: 'Selecciona el producto de tu interés para continuar'
        //             }
        //         }
        // }

        if (!telefono) {
            errors = {
                ...errors,
                telefono: {
                    message: 'Ingresa tu número de telefono para continuar'
                }
            }
        } else {
            if (telefono.length < 10) {
                errors = {
                    ...errors,
                    telefono: {
                        message: 'Ingresa 10 dígitos para fijo o móvil.'
                    }
                }
            } else if (!telefono.match(/^3|^60/)) {
                errors = {
                    ...errors,
                    telefono: {
                        message: 'El móvil ingresado debe empezar en 3 o para teléfono fijo en 60 + Indicativo + Número de teléfono, ejemplo: 6017500500'
                    }
                }
            }
        }

        if (!autorizacion) {
            errors = {
                ...errors,
                autorizacion: {
                    message: 'Acepta el tratamiento de datos para continuar.'
                }
            }
        }

        setErrors(errors)
        console.log("mostrando errores", errors)
        if (Object.keys(errors).length === 0) {
            procesoSolicitud()
        } else {
            setDisabledContinua(false)
        }
    }

    const setNumberValid = value => {
        if (isNaN(value)) {
            return;
        }

        setTelefono(value)

        if (value.startsWith("60")) {
            setTipo_telefono(1)
        } else if (value.startsWith("3")) {
            setTipo_telefono(2)
        }
    }

    async function procesoSolicitud() {
        let precioPlan = document.getElementById(`PRECIO_${fi_PLAN}`)
        precioPlan = precioPlan.textContent
        let idProducto = PlanContratacionCAL[0]?.fc_TIPO_CAMPANIA
        let producto = PlanContratacionCAL[0]?.fc_NOMBRE_CAMPANIA
        let referencia_productoC = localStorage.getItem('referencia_producto')
        referencia_productoC = referencia_productoC += "*" + name.replaceAll(" ", "_")

        let resumen_planVal = ""
        Caracteristicas?.map((item, index) => (
            resumen_planVal += item?.fc_TITULO.replace(':', '') + ":" + item?.fc_VALOR + "*"
        ))
        resumen_planVal = resumen_planVal.replace(/\*$/, "")
        resumen_planVal += `${resumen_planVal} * $${precioPlan}`

        let idFamilia = localStorage.getItem('id_familia')
        let url_servicio_web = idFamilia === 'SHO' ? localStorage.getItem('url_servicio_web_plan') : localStorage.getItem('url_servicio_web_plan')
        console.log("procesoSolicitud: resumen_plan",resumen_planVal.length, resumen_planVal )
        const configValidaI = {
            method: 'POST',
            url: url_servicio_web + 'validarIntentosTelefono',
            data: { fc_num_tel: telefono },
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json"
            }
        }

        let response = await axios(configValidaI)
        console.log("response- validarIntentosTelefono------------------------->", resumen_planVal, response);
        if (response.status === 200 && response?.data?.autorizar) {
            const data = {
                idProducto:1,
                'idCiudad': ciudad,
                idFormulario: 1,
                nombres:"",
                apellidos:"",
                cedula:"",
                'ciudad': ciudadName,
                email:"",
                tipo_telefono,
                telefono,
                extension,
                'producto': producto,
                'optin': autorizacion ? 1 : 0,
                gclid:"",
                utm_source:"",
                utm_campaign:"",
                utm_medium:"",
                queu_promo:"",
                referencia_producto: referencia_productoC,
                canal_trafico:"ORGANICO",
                resumen_plan: resumen_planVal
            }
            /*const data = {
                canal_trafico: "ORGANICO",
                idProducto,
                'idCiudad': ciudad,
                idFormulario: 1,
                //nombres,
                //apellidos,
                //cedula,
                'ciudad': ciudadName,
                //email,
                tipo_telefono,
                telefono,
                extension,
                'producto': producto,
                'optin': autorizacion ? 1 : 0,
                //glid,
                //utm_source,
                //utm_campaign,
                //utm_medium,
                //queu_promo,
                referencia_producto: referencia_productoC,
                //canal_trafico,
                resumen_plan: resumen_planVal
                //Titulo(reemplazar ":"):Valor Cargo Fijo Mensual:$55.900 Impuestos Incluidos*Minutos Incluidos a Todo Destino:Ilimitado*Navegación en Internet:30GB y hasta 10GB para compartir con otros dispositivos cercanos.*Aplicaciones Incluidas:Facebook_WhatsApp_Twitter*Otros Obsequios Inclui
            }*/

            console.log("data", data)

            const configSolicitud = {
                method: 'POST',
                url: url_servicio_web + 'procesoSolicitud',
                data: data,
                headers: {
                    'Accept': "application/json",
                    'Content-Type': "application/json"
                }
            }
            console.log("configSolicitud", configSolicitud)
            try {
                let response =  await axios(configSolicitud)
                console.log("response- procesoSolicitud------------------------->", response);
                if (response.status === 200 && response?.data > 0) {
                    
                    /*if (value_promo !== undefined && value_promo !== null) {
                        setMensajeSolicitud(value_promo)
                    }*/
                    if (idProducto !== "-1" && idProducto !== null) {
                        setMensajeSolicitud(idProducto)
                    }
                    else if (idProducto !== "" && idProducto !== null) {
                        setMensajeSolicitud(idProducto)
                    }
                    setIdSolicitud(response.data)
                    setSuccess(true)
                } else {
                    setDisabledContinua(false)
                }
            } catch (error) {
                let errors = {
                        service: {
                            message: 'Ha ocurrido un error, vuelva a intentarlo'
                        }
                    }
                setErrors(errors)
                console.log("response- procesoSolicitud error------------------------->", error);
                setDisabledContinua(false)
            }
        } else {
            setDisabledContinua(false)
            if (!response.data.autorizar) {
                let errors = {
                    telefono: {
                        message: 'No se pudo validar el telefono'
                    }
                }
                if (response.data.mensaje) {
                    errors = {
                        telefono: {
                            message: response.data.mensaje
                        }
                    }
                }
                setErrors(errors)

            }
        }



    }
    function clarErrorValue(){
        setErrors({})
    }
    function clearClassStatusPlanComparador() {
        //setStatusClass('')
        //setErrorField('')
        setAlertCond(false)
        //setInputDisabled(false)
        //setLocalTelefono('')
        
        setTelefono('')
        setCiudad('-1')
        setAutorizacion(false)
        setSuccess(false)
        setDisabledContinua(false)
        setErrors({})
    }
    /*function phoneTypeComparador(e) {
        let ItemphoneArea = e.target.value
        let phoneAreaCode = ItemphoneArea === "fijo" ? "+56" : "+569";
        setPhoneCode(phoneAreaCode)
        let maxlengthInput = ItemphoneArea === "fijo" ? 9 : 8;
        setMaxlengthPhone(maxlengthInput)
        let localTelefonotipo = ItemphoneArea === "fijo" ? "fijo" : "movil";
        setLocalTelefono_tipo(localTelefonotipo)
        clearClassStatusPlanComparador()
        setLocalTelefono('')
    }*/

    /*function validateOnlyNumbersComparador(e) {
        clearClassStatusPlanComparador()
        let regex = /^[0-9\b]+$/;
        let inputVal = e.target.value
        if (inputVal === '' || regex.test(inputVal)) {
            // console.log("numberssssssssssssssssssssss::::::" + inputVal)
            setLocalTelefono(inputVal)
        }
    }*/

    /*function errorSetDataStylePlanComparador(maxim = null, errorServer = null) {
        console.log("errorSetDataStylePlanComparador: ")
        let defaultError = "Ha ocurrido un error, vuelva a intentarlo"

        if (maxim) {
            setErrorField("El valor debe ser de " + maxim + " caracteres.")
            setStatusClass('error')
        }
        else {
            // if (errorServer != null) {
            if (errorServer === "Error en el servicio.") {
                defaultError = errorServer
            }
            setNotification(defaultError)
            // $(DivmSolicitar).find("[id=message]").text(defaultError);
        }
    }

    function magazineSubmitPlanComparador(c, urlsendData = null, PlanContratacionCAL) {
        clearClassStatusPlanComparador()
        console.log("magazineSubmitPlanComparador.......................")

        if (localTelefono.length < maxlengthPhone) {
            errorSetDataStylePlanComparador(maxlengthPhone)
            // setAlertCond(true)
        } else {
            console.log("sending...");
            sendDataPlan(urlsendData, PlanContratacionCAL);
            setInputDisabled(true)
            setAlertCond(true)
            setCallCond(false)
        }
    }*/

    /*function successSetDataStyleComparador() {
        setStatusClass('success')
        setNotification("Tus datos fueron inscritos correctamente.<br><strong>Pronto nos comunicaremos contigo.</strong>")
    }*/

    const searchCharacteristics = (search, lstPlanContratacionxPlan) => {

        const data = lstPlanContratacionxPlan?.length ? lstPlanContratacionxPlan : [];
        const newCaractData = data.filter(function (PlanContra) {
            let lstPlan = []

            lstPlan = PlanContra.fc_OPCION_LBX
            // console.log("to search---------- TypeFlag:", lstPlan, search)
            return lstPlan === search
        })
        // console.log("to search---------- TypeFlag:", TypeFlag, search, newCaractData, newCaractData.length)
        return newCaractData

    }

    let PlanContratacionCAL = searchCharacteristics('CAL', lstPlanContratacionxPlan)
    let PlanContratacionCHV = searchCharacteristics('CHV', lstPlanContratacionxPlan)
    let PlanContratacionCLN = searchCharacteristics('CLN', lstPlanContratacionxPlan)

    // console.log("PlanContratacion FC_OPCION_LBXto search----------", PlanContratacionCAL, PlanContratacionCHV, PlanContratacionCLN)

    /*async function sendDataPlan(urlsendData = null, PlanContratacionCAL) {

        let urlAjaxsendData = "sendDataPersonas"
        if (urlsendData != null) {
            urlAjaxsendData = urlsendData;
        }


        var SendDataPersonasRequest = {
            localRut1: PlanContratacionCAL.fc_RUT_DEFAULT ? PlanContratacionCAL.fc_RUT_DEFAULT : "",
            localTelefono: localTelefono ? localTelefono : "",
            localServicio: PlanContratacionCAL.fc_SERVICIO ? PlanContratacionCAL.fc_SERVICIO : "",
            localSegmento: PlanContratacionCAL.fc_SEGMENTO ? PlanContratacionCAL.fc_SEGMENTO : "",
            localCliente: PlanContratacionCAL.fc_TIPOCLIENTE ? PlanContratacionCAL.fc_TIPOCLIENTE : "",
            localTelefono_tipo: localTelefono_tipo ? localTelefono_tipo : "",
            localProducto: PlanContratacionCAL.fc_PRODUCTO ? PlanContratacionCAL.fc_PRODUCTO : "",
            localCanal: PlanContratacionCAL.fc_CANAL ? PlanContratacionCAL.fc_CANAL : "",
            localId_c2c: PlanContratacionCAL.fc_ID_C2C ? PlanContratacionCAL.fc_ID_C2C : "",
            localmail: PlanContratacionCAL.fc_mail ? PlanContratacionCAL.fc_mail : "mail@mail.com",
        };

        var jsonSendData = JSON.stringify(SendDataPersonasRequest);
        console.log("Entramos en sendDataPersonas", urlAjaxsendData);
        console.log(jsonSendData);
        let url_envio_formulario = localStorage.getItem('url_envio_formulario')
        const configMagazineService = {
            method: 'POST',
            url: url_envio_formulario,
            data: jsonSendData,
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json"
            },
        };
        try {
            let response = await axios(configMagazineService)
            // clearClassStatusPlanComparador()
            successSetDataStyleComparador()
            console.log("response- configMagazineService------------------------->", response, response.data);
        } catch (error) {
            errorSetDataStylePlanComparador(null, error)
            setStatusClass('error')
            console.log("response- configMagazineService-------------------------> Error.....", error);
        }

        // setAlertCond(true)


        // ajax({
        //     url: "/magazineService/" + urlAjaxsendData,
        //     type: "POST",
        //     data: jsonSendData,
        //     dataType: "json",
        //     contentType: "application/json; charset=utf-8",
        //     success: function (data) {
        //         console.log(data, data.localMessage);
        //         if (data.localExecutionCode == 2 || data.localExecutionCode == 3 || data.localIdTrans == 0) {
        //             if (data.localIdTrans == 0) {
        //                 data.localMessage = 'Error en el servicio.'
        //             }
        //             // $(DivmSolicitar).find("[id=message]").text(data.localMessage);
        //             errorSetDataStylePlanComparador(null, data.localMessage)
        //             // errorSetDataStylePlan
        //             // $(DivmSolicitar).find("button[name='btn-tertiary-transp']").attr("style", "display: block ")
        //             // $(DivmSolicitar).find("a[name='btn-more-options']").attr("style", "display: block ")
        //             //set css error
        //         } else {
        //             //clear css error
        //             clearClassStatusPlan(index)
        //             successSetDataStylePlan(index)
        //         }
        //         // $(DivmSolicitar).find("input[name='localRut1']").prop("disabled", false);
        //         // $(DivmSolicitar).find("[id=localTelefono]").prop("disabled", false);
        //     },
        //     error: function (xhr, ajaxOptions, thrownError) {

        //         // $(DivmSolicitar).find("input[name='localRut1']").prop("disabled", false);
        //         // $(DivmSolicitar).find("[id=localTelefono]").prop("disabled", false);
        //         // $(DivmSolicitar).find("button[name='btn-tertiary-transp']").attr("style", "display: block ")
        //         // $(DivmSolicitar).find("a[name='btn-more-options']").attr("style", "display: block ")

        //         errorSetDataStylePlanComparador(null, xhr.status)
        //         console.log(thrownError);
        //         console.log(xhr.status);
        //     }
        // });
    }*/
    console.log("disabledContinua", disabledContinua)
    return (
        <div className="modalClaro mSolicitar">
            <div className="mSolicitarCont">
                <p className="mSolTitle">{title}:</p>
                <p className="mSolTitle">{name}</p>
                <div className="mSolBundle">
                    {
                        fc_DESCRIPCION?.includes("Televi") || fc_DESCRIPCION?.includes("televi")
                            ? <p><i className="ico-tv"></i><span>TV</span></p>
                            : null
                    }
                    {
                        fc_DESCRIPCION?.includes("Internet") || fc_DESCRIPCION?.includes("internet")
                            ? <p><i className="ico-tv"></i><span>Internet</span></p>
                            : null
                    }
                    {
                        fc_DESCRIPCION?.includes("Telef") || fc_DESCRIPCION?.includes("telef")
                            ? <p><i className="ico-tv"></i><span>Telefónia</span></p>
                            : null
                    }
                </div>
                {errors?.producto?.message &&
                    <div className="c13Alerts">
                        <div className="notification error">
                            <p>
                                {errors?.producto?.message}
                            </p>
                        </div>
                    </div>
                }
                {/* <p className="mSolDesc">{fc_DESCRIPCION}</p> */}
                {
                    !callCond && !alertCond ?
                        <div className="mSolSubs" id="mSolOptions">
                            <p>Selecciona una opcion de contratación:</p>
                            {
                                PlanContratacionCLN.length
                                    ?
                                    <a className="btn btnPrimario withIco" href={`${PlanContratacionCLN[0].fc_URL}`}>
                                        <i className="ico-mouse-pointer"></i>
                                        <span>Contrata Online</span>
                                    </a>
                                    : null
                            }
                            {
                                PlanContratacionCAL.length
                                    ?
                                    <a className="btn btnPrimario withIco" id="callMeNowBtn" href="#!" onClick={() => setCallCond(c => !c)}>
                                        <i className="ico-phone"></i>
                                        <span>Llámenme Ahora</span>
                                    </a>
                                    : null
                            }
                            {
                                PlanContratacionCHV.length
                                    ?
                                    <a className="btn btnPrimario withIco" href={`${PlanContratacionCHV[0].fc_URL}`}>
                                        <i className="ico-message-circle"></i>
                                        <span>WhatsApp</span>
                                    </a>
                                    : null
                            }
                            
                        </div>
                        : <></>
                }
                {
                    !success && callCond ?
                            <form className="modalClaro mSolicitarContact" 
                            onSubmit={(e) => onSubmitForm(e)}
                            >
                                <p className='mSolicitarContactTitle'>
                                    Ingresa tus datos y nos contactaremos contigo
                                </p>

                                <div className="mSolicitarContactSelect">

                                    <label htmlFor=""> *Ciudad</label>

                                    <span className="select">
                                        <select   value={ciudad} onChange={e => {
                                            setCiudad(e.target.value)
                                            setCiudadName(e.target.options[e.target.selectedIndex].text)
                                            clarErrorValue()
                                        }}>
                                            <option value="-1" disabled>Selecciona ciudad</option>
                                            {optionsCiudades}
                                            
                                        </select>
                                    </span>
                                </div>
                                {errors?.ciudad?.message &&
                                    <div className="c13Alerts">
                                        <div className="notification error">
                                            <p>
                                                {errors?.ciudad?.message}
                                            </p>
                                        </div>
                                    </div>
                                }
                                <div className="phoneFields mSolicitarNumb">
                                    <label htmlFor="">Tu número de Celular o fijo</label>
                                    
                                    <fieldset className="">
                                    
                                        <TextField
                                            placeholder='Número fijo o celular'
                                            className=''
                                            maxLength='10'
                                            name='phoneNumber'
                                            value={telefono}
                                            onChange={e=>{setNumberValid(e.target.value); clarErrorValue()}} 
                                        >

                                        </TextField>
                                    </fieldset>
                                    {errors?.telefono?.message &&
                                        <div className="c13Alerts">
                                            <div className="notification error">
                                                <p>
                                                    {errors?.telefono?.message}
                                                </p>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className='mSolicitarContactAut'>
                                    
                                    <InputSelect 
                                        type={InputSelectType.CHECKBOX} 
                                        //register={register("auth", {required: true})} 
                                        text='Autorizo el tratamiento de mis datos personales' 
                                        defaultValue=''
                                        name='auth' 
                                        checked={autorizacion}
                                        onChange={e => {setAutorizacion(e.target.checked); clarErrorValue()}}
                                        className=''
                                    />
                                </div>
                                {errors?.autorizacion?.message &&
                                    <div className="c13Alerts" >
                                        <div className="notification error">
                                            <p>
                                                {errors?.autorizacion?.message}
                                            </p>
                                        </div>
                                    </div>
                                }
                                {errors?.service?.message &&
                                    <div className="c13Alerts" >
                                        <div className="notification error">
                                            <p>
                                                {errors?.service?.message}
                                            </p>
                                        </div>
                                    </div>
                                }
                                <div className='mSolicitarContactAct'>
                                    <button className={`btn btnPrimario ${disabledContinua ? 'disabled' : ''}`} disabled={disabledContinua}  type='submit' >Enviar </button>
                                    {
                                        fi_SERVICIO === null
                                            ?<a className="textLink" id="mSolOptionsBtn" href="#!" onClick={() => { setCallCond(c => !c); setSuccess(false); clearClassStatusPlanComparador(); }}>Ver otras opciones</a>
                                            :null
                                    }
                                </div>
                                
                            </form>
                        : <></>
                }
                {
                                    success ?
                                        <div className="c2cAlerts">
                                            <h3>Tus datos se han recibido con &eacute;xito</h3>
                                            <div className="notification success">
                                                <p>Se ha registrado el n&uacute;mero {telefono} en la solicitud {idSolicitud} producto {mensajeSolicitud}</p><span className="ico-x"></span>
                                            </div>
                                            {/* <div className="notification error">
                                                <p>{notification}</p><span className="ico-x"></span>
                                            </div> */}
                                            <a className="textLink" href="#!" onClick={() => { setCallCond(c => !c); setAlertCond(c => !c); setSuccess(false); clearClassStatusPlanComparador(); }}>Vuelve a enviarnos tu número</a>
                                        </div>
                                        : <></>
                                }
            </div>
        </div>
    )
}

MSolicitarPartModal.defaultProps = {}

// MSolicitarPartModal.propTypes = {}

export default MSolicitarPartModal
